

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);




//////////////////
// WEBPACK FOOTER
// ../node_modules/hasown/index.js
// module id = ../node_modules/hasown/index.js
// module chunks = 1